import { render } from "./Other.vue?vue&type=template&id=12da3d57&scoped=true"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"

import "./Other.scss?vue&type=style&index=0&id=12da3d57&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12da3d57"]])

export default __exports__